import { useContext, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";

const LANGS = {
  en: "EN",
  ar: "AR",
  ku: "KU",
};

const LanguageSelector = ({ variant = "light" }) => {
  const { currentLang, changeLanguage } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  const isDark = variant === "dark";

  return (
    <div className="relative" dir="ltr">
      <button
        onClick={() => setOpen((prev) => !prev)}
        className={
          isDark
            ? "px-3 py-1 border border-black/40 text-black text-sm tracking-wider hover:bg-black/5 transition rounded"
            : "px-3 py-1 border border-white/40 text-white text-sm tracking-wider hover:bg-white/10 transition rounded"
        }
      >
        {LANGS[currentLang]}
      </button>

      {open && (
        <div
          className={
            isDark
              ? "absolute right-0 mt-2 w-20 bg-white/95 border border-black/15 backdrop-blur rounded shadow-lg z-50"
              : "absolute right-0 mt-2 w-20 bg-black/80 border border-white/20 backdrop-blur rounded shadow-lg z-50"
          }
        >
          {Object.entries(LANGS).map(([key, label]) => (
            <button
              key={key}
              onClick={() => {
                changeLanguage(key);
                setOpen(false);
              }}
              className={
                isDark
                  ? `w-full px-3 py-2 text-sm text-left hover:bg-black/5 ${
                      currentLang === key ? "text-black" : "text-black/60"
                    }`
                  : `w-full px-3 py-2 text-sm text-left hover:bg-white/10 ${
                      currentLang === key ? "text-white" : "text-white/60"
                    }`
              }
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
